import { tuiStringHashToHsl } from '@taiga-ui/kit';
import { Maybe } from '@iss/libs/graphql';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

import { AvatarInitialsPipe } from './avatar-initials.pipe';

import { IconComponent, IconName } from '@iss/core/icon';

@Component({
  selector: 'iss-avatar',
  templateUrl: './avatar.component.html',
  styleUrls: [ './avatar.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [ AvatarInitialsPipe, NgIf, IconComponent ],
})
export class AvatarComponent {
  @Input() public username: Maybe<string>;
  @Input() public active: Maybe<boolean>;
  @Input() public autoColor = true;
  @Input() public color: Maybe<string>;
  @Input() public src: Maybe<string>;
  @Input() public icon: Maybe<IconName>;

  public get bgColor(): string {
    return this.autoColor ? tuiStringHashToHsl(this.username || '') : '#ffffff';
  }

  public get bgImage(): string | undefined {
    return this.src ? `url('${ this.src }')` : undefined;
  }

  public get hasIcon(): boolean {
    return !this.bgImage && Boolean(this.icon);
  }

  public get hasInitials(): boolean {
    return !this.bgImage && !this.hasIcon && Boolean(this.username);
  }
}
